import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AiAssistantService, AiContext } from '../../services/ai-assistant.service';

/**
 * ASK AI — har screen par baitha hua button.
 *
 * ── WHY IT IS NOT IN THE MENU ────────────────────────────────────────────────
 * AI costs third-party money, so not every org gets it. Putting it in the menu
 * means a rollout across 287 menu sets; a flag means one row.
 *
 * ── NOTHING SHOWS UNTIL THERE IS AN ENTITLEMENT ──────────────────────────────
 * For an org without the feature this component renders NOTHING at all — no
 * icon, no space. Showing a "locked" button is actively worse: it is a daily
 * reminder of something they do not have.
 *
 * One exception: if the SaaS has granted it but the org has not agreed yet, the
 * admin does see it — because they are the person who can agree.
 */
@Component({
  selector: 'app-ai-fab',
  templateUrl: './ai-fab.component.html',
  styleUrls: ['./ai-fab.component.scss'],
})
export class AiFabComponent implements OnInit {
  ctx: AiContext | null = null;

  constructor(public ai: AiAssistantService, private router: Router) {}

  ngOnInit(): void {
    this.ai.context$.subscribe((c) => (this.ctx = c));
    this.ai.load();
  }

  /** Whether it is shown at all. */
  get show(): boolean {
    if (!this.ctx) return false;
    if (this.ctx.allowed) return true;
    return this.ctx.code === 'NEEDS_CONSENT' && !!this.ctx.can_accept;
  }

  /** Something wants attention — a small dot. */
  get dot(): boolean {
    if (!this.ctx) return false;
    if (this.ctx.code === 'NEEDS_CONSENT') return true;
    const d = this.ctx.diagnosis || [];
    return d.length > 0 && d[0].code !== 'ok';
  }

  get label(): string {
    return this.ctx && this.ctx.code === 'NEEDS_CONSENT' ? 'Turn on Ask AI' : 'Ask AI';
  }

  open(): void {
    const pid = this.ai.currentProjectId();
    this.router.navigate(['/user/ai-assistant'], pid ? { queryParams: { project: pid } } : {});
  }
}
